import { selectIsUserAgent } from './selectIsUserAgent';
import { IAppState } from '../common/state';

export const selectIsProfessionalSearchPromoBannerVisible = (state: IAppState) => {
  const isAgent = selectIsUserAgent(state);

  return isAgent;
};
